// extracted by mini-css-extract-plugin
export default {"mainContainer":"IzvestajiOPrometuPage_mainContainer__apzIs"};